module.exports = __webpack_public_path__ + "img/quest_icon_0022_defense.bac8755a.png";